import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import LogicContext from '../../Context/LogicContext';
import StockAdjustmentItemSelect from './StockAdjustmentItemSelect';
import StockAdjustmentWarehouse from './StockAdjustmentWarehouse';
import GeneralModal from '../../helpers/GeneralModal';
import { createModal } from 'react-modal-promise';
import { stockService } from '../../services/stockService';
import {  GetStockAdjustmentEdit, ResetAdjustmentEdit, GetStockAdjustmentList } from "../../store/stockAdjustmentAtom";


const InventoryItemRow = ({ item_id, item_name, item_sku, item_category_name, setup_quantity_per_unit, onDelete, onQuantityChange, onItemRateChange }) => (
  <tr className="hover:bg-gray-50 transition-colors">
    <td className="px-6 py-4 text-sm text-gray-700">{item_id}</td>
    <td className="px-6 py-4 font-medium text-gray-900">{item_name}</td>
    <td className="px-6 py-4 text-sm text-gray-600">{item_sku || '-'}</td>
    <td className="px-6 py-4 text-sm text-gray-600">{item_category_name || '-'}</td>
    <td className="px-6 py-4">
      <input
        type="number"
        min="1"
        className="w-24 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        value={setup_quantity_per_unit}
        onChange={(e) => onQuantityChange(item_id, e.target.value)}
      />
    </td>


    <td className="px-6 py-4 text-center">
      <button onClick={onDelete} className="text-red-600 hover:text-red-800 transition-colors" title="Remove item">
        <span className="material-icons text-xl">delete_outline</span>
      </button>
    </td>
  </tr>
);

const StockAdjustmentAddNewPage = () => {
  const getStockData = GetStockAdjustmentList();
  const stockEdit = GetStockAdjustmentEdit();
  const resetEdit = ResetAdjustmentEdit();
  const myPromiseModal = createModal(GeneralModal);
  const navigate = useNavigate();
  const { showToast, httpResponseManager } = useContext(LogicContext);

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const [itemList, setItemList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [requiredQuantity, setRequiredQuantity] = useState('1');




  useEffect(()=> {
    if(stockEdit?.adjustment_main?.length){
      document.title = 'Modify Stock Adjustment';
      setValue('warehouse_id', stockEdit?.adjustment_main?.[0]?.warehouse_id);
      setValue('ref_no', stockEdit?.adjustment_main?.[0]?.ref_no);
      setValue('remark', stockEdit?.adjustment_main?.[0]?.adjustment_remark);
      if(stockEdit?.adjustment_details?.length){
        let newList =  stockEdit.adjustment_details.map((item)=> {
          return {...item,setup_quantity_per_unit:item?.item_quantity || 0,
           
          }
        })
        setItemList(newList);
      }
    }

    return(()=> {
      resetEdit();
    })

  },[stockEdit]);


  const handleAddItem = () => {
    if (!selectedProduct?.Item_Id) {
      return showToast('Please select an item', 'error');
    }
    if (!requiredQuantity || requiredQuantity < 1) {
      return showToast('Please enter a valid quantity (minimum 1)', 'error');
    }
    if (itemList.some(i => i.item_id === selectedProduct.Item_Id)) {
      return showToast('This item is already added', 'error');
    }

    setItemList(prev => [
      ...prev,
      {
        item_id: selectedProduct.Item_Id,
        item_name: selectedProduct.Item_Name,
        item_sku: selectedProduct.Item_Sku,
        item_category_name: selectedProduct.Category_Name || '-',
        setup_quantity_per_unit: requiredQuantity,
      },
    ]);

    setSelectedProduct({});
    setRequiredQuantity('1');
    document.activeElement?.blur();
  };

  const handleRemoveItem = (itemId) => {
    setItemList(prev => prev.filter(item => item.item_id !== itemId));
  };

  const handleQuantityChange = (itemId, value) => {
    const qty = parseFloat(value) || 1;
    if (qty < 1) {
      showToast("Quantity cannot be less than 1", "error");
      return;
    }
    setItemList(prev =>
      prev.map(item =>
        item.item_id === itemId ? { ...item, setup_quantity_per_unit: qty } : item
      )
    );
  };

  const onSelItemRateChange = ( value) => {
    const newRate = parseFloat(value) || 1;
    if (newRate < 1) {
      showToast("Quantity cannot be less than 1", "error");
      return;
    }
    setSelectedProduct(selectedProduct);
   
  };


  const onItemSelect = (item) => {
    setSelectedProduct(item);
  };

  const onWarehouseSelect = (warehouse) => {
    setValue('warehouse_id', warehouse.warehouse_id);
  };

  const onSubmit = async () => {
    let option = '1';
    if(stockEdit?.adjustment_main?.[0]?.ref_no){
      option = '2';
    }
    if (itemList.length === 0) {
      return showToast('Please add at least one item', 'error');
    }

    const confirm = await myPromiseModal({
      title: 'Confirm Submission',
      body: 'Do you want to save this stock adjustment?',
      showInput: false,
    });
    

    if (!confirm?.decision) return;

    const formData = getValues();
    const xmlItems = itemList
      .map(item => `<a><item_id>${item.item_id}</item_id><item_quantity>${item.setup_quantity_per_unit}</item_quantity> </a>`)
      .join('');

    const payload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      payload.set(key, value || '');
    });
    payload.set('option', option);
    payload.set('xml_string_item', `<root>${xmlItems}</root>`);

    try {
      const res = await stockService.submitStockAdjustment(payload);
      const response = httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);

      if (response.message_id === 1) {
        showToast(response.message_text || 'Stock adjustment saved successfully!', 'success');
        sessionStorage.setItem('reloadPage', 'true');
        navigate(-1);
      } else {
        showToast(response.message_text || 'Failed to save', 'error');
      }
    } catch (err) {
      // showToast('Error submitting form', 'error');
    }
  };

  const baseDateData = stockEdit?.adjustment_main?.[0]?.adjustment_date_string;
const defaultDate = baseDateData 
  ? moment(baseDateData, 'DD-MM-YYYY').format('YYYY-MM-DD') 
  : moment().format('YYYY-MM-DD');



  return (
    <div className="max-w-6xl mx-auto p-6 bg-gray-50 min-h-screen">
      <div className="bg-white rounded-xl shadow-lg p-8">

        {/* Header */}
        <h1 className="text-3xl font-bold text-gray-800 mb-8">  {stockEdit?.adjustment_main?.[0]?.ref_no ? "Update Stock Adjustment":"New Stock Adjustment"}</h1>

        {/* Adjustment Date & Warehouse - NOW AT THE TOP */}
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 mb-8">
          <h2 className="text-lg font-semibold text-amber-900 mb-4">Adjustment Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Adjustment Date <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                // defaultValue={moment().format('YYYY-MM-DD')}
                defaultValue={defaultDate }
                {...register('adjustment_date', { required: 'Adjustment date is required' })}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              {errors.adjustment_date && (
                <p className="text-red-600 text-sm mt-1">{errors.adjustment_date.message}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Warehouse <span className="text-red-500">*</span>
              </label>
              <StockAdjustmentWarehouse
              defaultVal={{label:stockEdit?.adjustment_main?.[0]?.warehouse_name}}
                list={getStockData?.Warehouse || []}
                onWareHouseSelect={onWarehouseSelect}
                {...register('warehouse_id', { required: 'Warehouse is required' })}
              />
              {errors.warehouse_id && (
                <p className="text-red-600 text-sm mt-1">{errors.warehouse_id.message}</p>
              )}
            </div>
          </div>
        </div>

        {/* Item Selection Section */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
          <h2 className="text-lg font-semibold text-blue-900 mb-4">Add Items to Adjust</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Select Item</label>
              <StockAdjustmentItemSelect onOptionSelect={onItemSelect} />
            </div>


            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Quantity</label>
              <input
                type="number"
                min="1"
                value={requiredQuantity}
                onChange={(e) => setRequiredQuantity(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                placeholder="e.g. 10"
              />
            </div>


          

            <div>
              <button
                type="button"
                onClick={handleAddItem}
                className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2.5 rounded-lg transition flex items-center justify-center gap-2"
              >
                <span className="material-icons text-xl">add</span>
                Add Item
              </button>
            </div>
          </div>
        </div>

        {/* Items Table */}
        <div className="mb-8 overflow-hidden rounded-lg border border-gray-200">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">ID</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Name</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">SKU</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Category</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Quantity</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {itemList?.length === 0 ? (
                <tr>
                  <td colSpan={6} className="px-6 py-12 text-center text-gray-500">
                    No items added yet. Select an item above and click "Add Item".
                  </td>
                </tr>
              ) : (
                itemList?.map((item) => (
                  <InventoryItemRow
                    key={item.item_id}
                    {...item}
                    onDelete={() => handleRemoveItem(item.item_id)}
                    onQuantityChange={handleQuantityChange}
                  />
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Remark */}
        <div className="mb-8">
          <label className="block text-sm font-medium text-gray-700 mb-1">Remark (Optional)</label>
          <textarea
            {...register('remark')}
            rows={4}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="Add any notes or reason for this adjustment..."
          />
        </div>

        {/* Submit Buttons */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex justify-end gap-4 pt-6 border-t border-gray-200">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="px-6 py-3 bg-gray-600 hover:bg-gray-700 text-white font-medium rounded-lg transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition flex items-center gap-2"
            >
              <span className="material-icons">save</span>
              {stockEdit?.adjustment_main?.[0]?.ref_no ? "Update Adjustment":"Save Adjustment"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StockAdjustmentAddNewPage;